<template>
    <span>
        <Drawer title="用户证书" :closable="false" placement="right" v-model="certificate" width="60%">
            <Row>
                <Table :loading="loading" border :columns="columns" :data="data" sortable="custom" @on-sort-change="changeSort" @on-selection-change="showSelect" ref="table"></Table>
            </Row>
            <Row type="flex" justify="end" class="page">
                <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
            </Row>
        </Drawer>
    </span>
</template>

<script>
    import {userCertificateList} from "@/api/bus";
    import circleLoading from "../../../my-components/circle-loading.vue";

    export default {
        name: "work-manage",
        components: {
            circleLoading,
        },
        data() {
            return {
                certificate: false,
                loading: false, // 表单加载状态
                operationLoading: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                searchForm: {
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "createTime", // 默认排序字段
                    order: "desc", // 默认排序方式
                    userId: ""
                },
                selectDate: null, //选择日期绑定modal
                columns: [
                    {
                        type: "index",
                        width: 60,
                        fixed: "left",
                        align: "center"
                    },
                    {
                        title: "证书名称",
                        width: 300,
                        align: "center",
                        fixed: "left",
                        key: "certificateName"
                    },
                    {
                        title: "证书编号",
                        width: 200,
                        align: "center",
                        key: "certificateNum",
                    },
                    {
                        title: "证书转换证明",
                        width: 120,
                        align: "center",
                        key: "changeStatus",
                        render: (h, params) => {
                            if (params.row.changeStatus === 0) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "blue"
                                            }
                                        },
                                        "可申请证明"
                                    )
                                ]);
                            } else if (params.row.changeStatus === 1) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#E6941A"
                                            }
                                        },
                                        "已申请证明"
                                    )
                                ]);
                            } else if (params.row.changeStatus === 2) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#45c9e6"
                                            }
                                        },
                                        "已获得证明"
                                    )
                                ]);
                            } else if (params.row.changeStatus === 3) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "green"
                                            }
                                        },
                                        "转换成功"
                                    )
                                ]);
                            } else if (params.row.changeStatus === 4) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "red"
                                            }
                                        },
                                        "转换失败"
                                    )
                                ]);
                            } else {
                                return h("div", "--");
                            }
                        }
                    },
                    {
                        title: "颁证机构",
                        width: 300,
                        align: "center",
                        key: "award",
                    },
                    {
                        title: "颁证时间",
                        width: 150,
                        align: "center",
                        key: "awardTime",
                    },
                    {
                        title: "有效期",
                        align: "center",
                        width: 150,
                        key: "validity",
                    },
                    {
                        title: "上传登记时间",
                        align: "center",
                        width: 150,
                        key: "createTime",
                    },
                    {
                        title: "身份证号",
                        width: 200,
                        align: "center",
                        fixed: "right",
                        key: "idCard",
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            showDrawer(params){
                this.certificate = true;
                this.searchForm.userId = params;
                this.getDataList();
            },
            getDataList() {
                // 多条件搜索用户列表
                this.loading = true;
                userCertificateList(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            showSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
        },
        mounted() {
        }
    }
</script>
